module.exports = __webpack_public_path__ + "static/media/Nunito-Bold.9772667f.ttf";